import { Link } from "react-router-dom";
import React from "react";

// Style \\

import "../../assets/styles/sections/booking.scss";

const Booking = () => {
  return (
    <section className="booking">
      <div className="bg">
        <div className="container">
          <div className="booking_items">
            <div className="booking_items_content">
              <h3>Book an Appointment</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Convallis felis vitae
                tortor augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim et.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Convallis felis vitae
                tortor augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim et.
              </p>
            </div>
            <div className="booking_items_table">
              <div className="table_box">
                <form>
                  <div className="first">
                    <div className="input ">
                      <input
                        type="text"
                        className="other forBorder"
                        placeholder="Full Name"
                      />
                    </div>

                    <div className="input ">
                      <select
                        name="gender"
                        className="select"
                        placeholder="gender forBorder1"
                        id="cars"
                      >
                        <option value="volvo" selected>
                          Gender
                        </option>
                        <option value="volvo">Male</option>
                        <option value="saab">Female</option>
                      </select>
                    </div>
                  </div>

                  <div className="first">
                    <div className="input ">
                      <input
                        type="Num"
                        className="other phone"
                        placeholder="Phone"
                      />
                    </div>

                    <div className="input ">
                      <input
                        type="date"
                        className="other date"
                        placeholder="Date"
                      />
                    </div>
                  </div>

                  <div className="first">
                    <div className="input ">
                      <input type="time" className="other" placeholder="Time" />
                    </div>

                    <div className="input ">
                      <select
                        name="cars"
                        className="select doctorsSelect"
                        id="cars"
                      >
                        <option value="volvo" selected>
                          Doctors
                        </option>
                        <option value="volvo">Neurology</option>
                        <option value="saab">Bones</option>
                        <option value="saab">Oncology</option>
                        <option value="saab">Otorhinolaryngology</option>
                        <option value="saab">Ophthalmology</option>
                        <option value="saab">Cardiovascular</option>
                        <option value="saab">Pulmonology</option>
                        <option value="saab">Renal Medicine</option>
                        <option value="saab">Gastroenterology</option>
                        <option value="saab">Urology</option>
                        <option value="saab">Dermatology</option>
                        <option value="saab">Gynaecology</option>
                      </select>
                    </div>
                  </div>

                  <div className="textAreaNew">
                    <textarea
                      name="Message"
                      placeholder="What is your complaint"
                      cols="30"
                      rows="11"
                    ></textarea>
                  </div>

                  <div className="button_box">
                    <button>Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Booking;
